<div>
  <div class="form-section">
    <form [formGroup]="clientInformationForm">
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label for="claim_reference_no" class="required">Claim/Reference Number</label>
            <input type="number" class="form-control" id="claim_reference_no" formControlName="claim_reference_no"/>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="case_type" class="required">Case Type</label>
            <select id="case_type" class="form-control" multiSelect2 [fetchFn]="searchCaseType$" [formCtrl]="clientInformationForm.get('case_type')"></select>
            <app-validation-error [control]="clientInformationForm.get('case_type')"></app-validation-error>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label for="client_name" class="required">Client Name</label>
              <button class="btn text-dark-orange btn-link btn-sm text-decoration-none" (click)="openPopup(addClient)">Add New
                Client</button>
            </div>
            <select id="client_name" class="form-control" multiSelect2 [fetchFn]="searchClient$"
              [formCtrl]="clientInformationForm.get('client')" (change)="onChangeClient($event.target.value)"></select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label for="location" class="required">Location</label>
            <select type="text" class="form-control" id="location" formControlName="location" (change)="onChangeLocation($event.target.value)">
              <option value="">Select Location</option>
              <option [value]="location" *ngFor="let location of clientLocations">{{ location }}</option>
            </select>
          </div>
        </div>

        <div class="col-4">
          <div class="form-group">
            <label for="program_name">Program Name</label>
            <select type="text" class="form-control" id="program_name" formControlName="program_name" (change)="onChangeProgram($event.target.value)">
              <option value="">Select Program Name</option>
              <option [value]="program.id" *ngFor="let program of clientPrograms">{{ program.name }}</option>
            </select>
          </div>
        </div>

        <div class="col-4">
          <div class="form-group">
            <label for="primary_contact" class="required">Primary Contact</label>
            <select type="number" class="form-control" id="primary_contact" formControlName="primary_contact">
              <option value="">Select Primary Contact</option>
              <option [value]="contact.id" *ngFor="let contact of programLocationContacts">{{ contact.full_name }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col-4">
          <div class="form-group">
            <label for="companion_file">Companion File</label>
            <input type="text" class="form-control" id="companion_file" formControlName="companion_file"/>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="case_services">Case Services</label>
            <select id="case_services" class="form-control" multiSelect2 [fetchFn]="searchKeyServices$" [meta]="{multiple: true}" [formCtrl]="clientInformationForm.get('case_service')"></select>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="insured_date" class="required">Insured</label>
            <input type="text" class="form-control" id="insured_date" jDate [formCtrl]="clientInformationForm.get('insured_date')"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label for="location" class="required">DOL</label>
            <input type="text" class="form-control" id="dol" [formCtrl]="clientInformationForm.get('dol')" jDate>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="policy_number">Policy Number</label>
            <input type="number" class="form-control" id="policy_number" formControlName="policy_number"/>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="policy_period_from_date">Policy Period(From Date)</label>
            <input type="text" class="form-control" id="policy_period_from_date" jDate [formCtrl]="clientInformationForm.get('policy_period_from_date')"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label for="policy_period_to_date">Policy Period(To Date)</label>
            <input type="text" class="form-control" id="policy_period_to_date" jDate [formCtrl]="clientInformationForm.get('policy_period_to_date')" [meta]="{minDate: clientInformationForm.get('policy_period_from_date').value}"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mt-4 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm text-dark mr-1"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn spear-button-background btn-sm text-white"
            (click)="onSubmitForm()"
          >
            Save & Continue
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #addClient let-modal>
  <div class="modal-header">
    <h6>Add Client</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="addmodalService.dismissAll()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body create-client text-sm">
    <form [formGroup]="addClientForm">
      <div class="row mb-2">
        <div class="col-12">
          <div>
            <span class="text-dark fw-500 required" for="client_name"
              >Client Name</span
            >
            <input
              type="text"
              name="client_name"
              id="client_name"
              class="form-control"
              formControlName="name"
            />
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex justify-content-end">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-sm text-white mr-1"
            (click)="addmodalService.dismissAll()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn limos-button-background btn-sm text-white"
            (click)="addClientData()"
            [disabled]="addClientForm.invalid || isClientFormSubmitted"
          >
            Next
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>